import Tabs from '@/features/phone/components/Tabs'
import { usePhoneActiveScreen } from '@/features/phone/hooks/usePhoneActiveScreen'
import ExtendedOrderFinalization from '@/features/pos/components/OrderFinalization/Extended'
import { useScreenLayout } from '@/hooks/screen'
import { FC } from 'react'
import { View } from 'react-native'

const Layout: FC = () => {
    const screenLayout = useScreenLayout()

    const phoneScreen = usePhoneActiveScreen()

    if (screenLayout === 'compact') return <Tabs />

    return (
        <View style={{ flex: 1, flexDirection: 'row' }}>
            <Tabs />
            {phoneScreen === 'product-catalog' ? (
                <ExtendedOrderFinalization />
            ) : (
                <View style={{ flex: 1 }}></View>
            )}
        </View>
    )
}

export default Layout
